import Utils from "platform/util/Utils";
import WebUtil from "platform/util/WebUtil";

const UrlCloseSelf: boolean = Utils.parseBoolean(WebUtil.urlParam("closeSelf"));

export {
    UrlCloseSelf
};
